import { render, staticRenderFns } from "./FishingLibrary.vue?vue&type=template&id=682baaa7&"
import script from "./FishingLibrary.vue?vue&type=script&lang=js&"
export * from "./FishingLibrary.vue?vue&type=script&lang=js&"
import style0 from "./FishingLibrary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports